import type { SVGProps } from 'react'

export const Tasks = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="80"
    viewBox="0 0 81 80"
    width="81"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      fill="url(#paint0_linear_2794_12678)"
      height="35"
      rx="8"
      width="60"
      x="0.5"
    />
    <path
      d="M19.5 5.5C17.8431 5.5 16.5 6.84315 16.5 8.5C16.5 10.1569 17.8431 11.5 19.5 11.5H51.5C53.1569 11.5 54.5 10.1569 54.5 8.5C54.5 6.84315 53.1569 5.5 51.5 5.5H19.5ZM9.5 5.5C7.84315 5.5 6.5 6.84315 6.5 8.5C6.5 10.1569 7.84315 11.5 9.5 11.5C11.1569 11.5 12.5 10.1569 12.5 8.5C12.5 6.84315 11.1569 5.5 9.5 5.5Z"
      fill="url(#paint1_linear_2794_12678)"
      opacity="0.9"
    />
    <path
      d="M9.5 14.5C7.84315 14.5 6.5 15.8431 6.5 17.5C6.5 19.1569 7.84315 20.5 9.5 20.5H51.5C53.1569 20.5 54.5 19.1569 54.5 17.5C54.5 15.8431 53.1569 14.5 51.5 14.5H9.5Z"
      fill="url(#paint2_linear_2794_12678)"
      opacity="0.9"
    />
    <path
      d="M33.5 23.5C31.8431 23.5 30.5 24.8431 30.5 26.5C30.5 28.1569 31.8431 29.5 33.5 29.5H51.5C53.1569 29.5 54.5 28.1569 54.5 26.5C54.5 24.8431 53.1569 23.5 51.5 23.5H33.5Z"
      fill="url(#paint3_linear_2794_12678)"
      opacity="0.9"
    />
    <rect
      fill="url(#paint4_linear_2794_12678)"
      height="35"
      rx="8"
      width="60"
      x="10.5"
      y="22.5"
    />
    <path
      d="M29.5 28C27.8431 28 26.5 29.3431 26.5 31C26.5 32.6569 27.8431 34 29.5 34H61.5C63.1569 34 64.5 32.6569 64.5 31C64.5 29.3431 63.1569 28 61.5 28H29.5ZM19.5 28C17.8431 28 16.5 29.3431 16.5 31C16.5 32.6569 17.8431 34 19.5 34C21.1569 34 22.5 32.6569 22.5 31C22.5 29.3431 21.1569 28 19.5 28Z"
      fill="url(#paint5_linear_2794_12678)"
      opacity="0.9"
    />
    <path
      d="M19.5 37C17.8431 37 16.5 38.3431 16.5 40C16.5 41.6569 17.8431 43 19.5 43H61.5C63.1569 43 64.5 41.6569 64.5 40C64.5 38.3431 63.1569 37 61.5 37H19.5Z"
      fill="url(#paint6_linear_2794_12678)"
      opacity="0.9"
    />
    <path
      d="M43.5 46C41.8431 46 40.5 47.3431 40.5 49C40.5 50.6569 41.8431 52 43.5 52H61.5C63.1569 52 64.5 50.6569 64.5 49C64.5 47.3431 63.1569 46 61.5 46H43.5Z"
      fill="url(#paint7_linear_2794_12678)"
      opacity="0.9"
    />
    <foreignObject height="51" width="76" x="12.5" y="37">
      <div
        style={{
          backdropFilter: 'blur(4px)',
          clipPath: 'url(#bgblur_0_2794_12678_clip_path)',
          height: '100%',
          width: '100%'
        }}
      ></div>
    </foreignObject>
    <g data-figma-bg-blur-radius="8">
      <mask fill="white" id="path-9-inside-1_2794_12678">
        <path d="M20.5 53C20.5 48.5817 24.0817 45 28.5 45H72.5C76.9183 45 80.5 48.5817 80.5 53V72C80.5 76.4183 76.9183 80 72.5 80H28.5C24.0817 80 20.5 76.4183 20.5 72V53Z" />
      </mask>
      <path
        d="M20.5 53C20.5 48.5817 24.0817 45 28.5 45H72.5C76.9183 45 80.5 48.5817 80.5 53V72C80.5 76.4183 76.9183 80 72.5 80H28.5C24.0817 80 20.5 76.4183 20.5 72V53Z"
        fill="url(#paint8_linear_2794_12678)"
        fillOpacity="0.4"
      />
      <g
        clipPath="url(#paint9_angular_2794_12678_clip_path)"
        data-figma-skip-parse="true"
        mask="url(#path-9-inside-1_2794_12678)"
      >
        <g transform="matrix(4.12953e-10 0.0175 -0.03 2.80941e-09 50.5 62.5)">
          <foreignObject
            height="2057.14"
            width="2057.14"
            x="-1028.57"
            y="-1028.57"
          >
            <div
              style={{
                background:
                  'conic-gradient(from 90deg,rgba(255, 255, 255, 0.5692) 0deg,rgba(255, 255, 255, 0.8) 34.616deg,rgba(255, 255, 255, 0.2) 72.6934deg,rgba(255, 255, 255, 0.8) 124.617deg,rgba(255, 255, 255, 0.2) 304.62deg,rgba(255, 255, 255, 0.5692) 360deg)',
                height: '100%',
                width: '100%',
                opacity: 1
              }}
            ></div>
          </foreignObject>
        </g>
      </g>
      <path
        d="M28.5 45V45.5H72.5V45V44.5H28.5V45ZM80.5 53H80V72H80.5H81V53H80.5ZM72.5 80V79.5H28.5V80V80.5H72.5V80ZM20.5 72H21V53H20.5H20V72H20.5ZM28.5 80V79.5C24.3579 79.5 21 76.1421 21 72H20.5H20C20 76.6944 23.8056 80.5 28.5 80.5V80ZM80.5 72H80C80 76.1421 76.6421 79.5 72.5 79.5V80V80.5C77.1944 80.5 81 76.6944 81 72H80.5ZM72.5 45V45.5C76.6421 45.5 80 48.8579 80 53H80.5H81C81 48.3056 77.1944 44.5 72.5 44.5V45ZM28.5 45V44.5C23.8056 44.5 20 48.3056 20 53H20.5H21C21 48.8579 24.3579 45.5 28.5 45.5V45Z"
        data-figma-gradient-fill="{&#34;type&#34;:&#34;GRADIENT_ANGULAR&#34;,&#34;stops&#34;:[{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.096155457198619843},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.20192614197731018},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.34615889191627502},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.84616577625274658}],&#34;stopsVar&#34;:[{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.096155457198619843},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.20192614197731018},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.34615889191627502},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.84616577625274658}],&#34;transform&#34;:{&#34;m00&#34;:8.2590617012101575e-07,&#34;m01&#34;:-60.000011444091797,&#34;m02&#34;:80.50,&#34;m10&#34;:35.000003814697266,&#34;m11&#34;:5.6188200687756762e-06,&#34;m12&#34;:44.999996185302734},&#34;opacity&#34;:1.0,&#34;blendMode&#34;:&#34;NORMAL&#34;,&#34;visible&#34;:true}"
        mask="url(#path-9-inside-1_2794_12678)"
      />
    </g>
    <path
      d="M39.5 50.5C37.8431 50.5 36.5 51.8431 36.5 53.5C36.5 55.1569 37.8431 56.5 39.5 56.5H71.5C73.1569 56.5 74.5 55.1569 74.5 53.5C74.5 51.8431 73.1569 50.5 71.5 50.5H39.5ZM29.5 50.5C27.8431 50.5 26.5 51.8431 26.5 53.5C26.5 55.1569 27.8431 56.5 29.5 56.5C31.1569 56.5 32.5 55.1569 32.5 53.5C32.5 51.8431 31.1569 50.5 29.5 50.5Z"
      fill="url(#paint10_linear_2794_12678)"
      opacity="0.9"
    />
    <path
      d="M29.5 59.5C27.8431 59.5 26.5 60.8431 26.5 62.5C26.5 64.1569 27.8431 65.5 29.5 65.5H71.5C73.1569 65.5 74.5 64.1569 74.5 62.5C74.5 60.8431 73.1569 59.5 71.5 59.5H29.5Z"
      fill="url(#paint11_linear_2794_12678)"
      opacity="0.9"
    />
    <path
      d="M53.5 68.5C51.8431 68.5 50.5 69.8431 50.5 71.5C50.5 73.1569 51.8431 74.5 53.5 74.5H71.5C73.1569 74.5 74.5 73.1569 74.5 71.5C74.5 69.8431 73.1569 68.5 71.5 68.5H53.5Z"
      fill="url(#paint12_linear_2794_12678)"
      opacity="0.9"
    />
    <defs>
      <clipPath
        id="bgblur_0_2794_12678_clip_path"
        transform="translate(-12.5 -37)"
      >
        <path d="M20.5 53C20.5 48.5817 24.0817 45 28.5 45H72.5C76.9183 45 80.5 48.5817 80.5 53V72C80.5 76.4183 76.9183 80 72.5 80H28.5C24.0817 80 20.5 76.4183 20.5 72V53Z" />
      </clipPath>
      <clipPath id="paint9_angular_2794_12678_clip_path">
        <path
          d="M28.5 45V45.5H72.5V45V44.5H28.5V45ZM80.5 53H80V72H80.5H81V53H80.5ZM72.5 80V79.5H28.5V80V80.5H72.5V80ZM20.5 72H21V53H20.5H20V72H20.5ZM28.5 80V79.5C24.3579 79.5 21 76.1421 21 72H20.5H20C20 76.6944 23.8056 80.5 28.5 80.5V80ZM80.5 72H80C80 76.1421 76.6421 79.5 72.5 79.5V80V80.5C77.1944 80.5 81 76.6944 81 72H80.5ZM72.5 45V45.5C76.6421 45.5 80 48.8579 80 53H80.5H81C81 48.3056 77.1944 44.5 72.5 44.5V45ZM28.5 45V44.5C23.8056 44.5 20 48.3056 20 53H20.5H21C21 48.8579 24.3579 45.5 28.5 45.5V45Z"
          mask="url(#path-9-inside-1_2794_12678)"
        />
      </clipPath>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear_2794_12678"
        x1="30.5"
        x2="30.5"
        y1="0"
        y2="35"
      >
        <stop stopColor="#A8C8FF" />
        <stop offset="1" stopColor="#77ACFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint1_linear_2794_12678"
        x1="0.515668"
        x2="54.5384"
        y1="8.49998"
        y2="8.49998"
      >
        <stop offset="0.197112" stopColor="#77ACFF" />
        <stop offset="1" stopColor="#A8C8FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint2_linear_2794_12678"
        x1="0.515668"
        x2="54.5384"
        y1="17.5"
        y2="17.5"
      >
        <stop offset="0.197112" stopColor="#77ACFF" />
        <stop offset="1" stopColor="#A8C8FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint3_linear_2794_12678"
        x1="27.5078"
        x2="54.5192"
        y1="26.5"
        y2="26.5"
      >
        <stop offset="0.197112" stopColor="#77ACFF" />
        <stop offset="1" stopColor="#A8C8FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint4_linear_2794_12678"
        x1="40.5"
        x2="40.5"
        y1="22.5"
        y2="57.5"
      >
        <stop stopColor="#D5E3FF" />
        <stop offset="1" stopColor="#A8C8FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint5_linear_2794_12678"
        x1="10.5157"
        x2="64.5384"
        y1="31"
        y2="31"
      >
        <stop stopColor="#77ACFF" />
        <stop offset="1" stopColor="#A8C8FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint6_linear_2794_12678"
        x1="10.5157"
        x2="64.5384"
        y1="40"
        y2="40"
      >
        <stop stopColor="#77ACFF" />
        <stop offset="1" stopColor="#A8C8FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint7_linear_2794_12678"
        x1="37.5078"
        x2="64.5192"
        y1="49"
        y2="49"
      >
        <stop stopColor="#77ACFF" />
        <stop offset="1" stopColor="#A8C8FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint8_linear_2794_12678"
        x1="50.5"
        x2="50.5"
        y1="45"
        y2="80"
      >
        <stop stopColor="#77ACFF" />
        <stop offset="1" stopColor="#A8C8FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint10_linear_2794_12678"
        x1="74.5"
        x2="55.7742"
        y1="53.5"
        y2="76.9133"
      >
        <stop stopColor="white" stopOpacity="0.4" />
        <stop offset="1" stopColor="white" stopOpacity="0.8" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint11_linear_2794_12678"
        x1="74.5"
        x2="55.7742"
        y1="62.5"
        y2="85.9133"
      >
        <stop stopColor="white" stopOpacity="0.4" />
        <stop offset="1" stopColor="white" stopOpacity="0.8" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint12_linear_2794_12678"
        x1="74.5"
        x2="57.2441"
        y1="71.5"
        y2="82.2877"
      >
        <stop stopColor="white" stopOpacity="0.4" />
        <stop offset="1" stopColor="white" stopOpacity="0.8" />
      </linearGradient>
    </defs>
  </svg>
)
